import { APIRoute } from '@/modules/utils'
import { SendTokenStatus } from '@/modules/Stripe/apiTypes/base'

export const Route: APIRoute = {
  method: 'POST',
  path: '/v2/stripe/setup_intents',
}

export type Body = {
  status: string
  plan: string
  coupon: string
}

export type SearchParams = {
  paypal?: boolean
  plan?: string
}

export type Response = {
  id: string
  object: 'payment_intent' | 'setup_intent'
  customer: string
  clientSecret: string
  status: SendTokenStatus
  plan: string
}
